import React, { useMemo } from "react";
import { observer } from "mobx-react-lite";
import { useContext } from "react";
import { DataContext } from "../types";
import "./controls.scss";
import { state } from "../state";
function secondsToString(seconds) {
    const minute = Math.floor(seconds / 60).toString().padStart(2, "0");
    const second = Math.floor(seconds % 60).toString().padStart(2, "0");
    return `${minute}:${second}`;
}
export const Controls = observer(() => {
    const data = useContext(DataContext);
    state.duration = data.duration;
    const meetings = useMemo(() => {
        let meetings = [];
        let lastMeetingStartedAt = 0;
        for (const event of data.events) {
            if (event.type === "start_meeting") {
                lastMeetingStartedAt = event.timestamp;
            }
            else if (event.type === "vote_finish") {
                meetings.push({
                    start: lastMeetingStartedAt,
                    end: event.timestamp,
                });
            }
        }
        console.log(meetings);
        return meetings;
    }, [data.events]);
    return React.createElement("div", { className: "controls" },
        React.createElement("div", { className: "seekbar", onPointerDown: e => {
                e.currentTarget.setPointerCapture(e.pointerId);
            }, onPointerMove: e => {
                if (!e.currentTarget.hasPointerCapture(e.pointerId))
                    return;
                const rect = e.currentTarget.getBoundingClientRect();
                state.absoluteSeek(Math.min(((e.clientX - rect.left) / rect.width) * data.duration, data.duration));
            } },
            React.createElement("div", { className: "now", style: { width: `${(state.currentSeconds * 100) / data.duration}%` } }),
            meetings.map(meeting => {
                return React.createElement("div", { className: "meeting", key: `${meeting.start}-${meeting.end}`, style: {
                        left: `${(meeting.start * 100) / data.duration}%`,
                        width: `${((meeting.end - meeting.start) * 100) / data.duration}%`
                    } });
            })),
        React.createElement("div", { className: "buttons" },
            React.createElement("div", { className: "left" },
                React.createElement("button", { onClick: () => { state.playing = !state.playing; } }, state.playing ? "Pause" : "Play")),
            React.createElement("div", { className: "center" },
                secondsToString(state.currentSeconds),
                " / ",
                secondsToString(data.duration)),
            React.createElement("div", { className: "right" })),
        React.createElement("div", { className: "credits" },
            "AUReplayer | GitHub: ",
            React.createElement("a", { href: "https://github.com/rinsuki/aureplayer", target: "_blank" }, "rinsuki/aureplayer"),
            "."));
});
